export default `/* Ids Card Component */
.ids-card {
  background-color: var(--ids-card-color-background);
  border: 1px solid var(--ids-card-color-border);
  border-radius: var(--ids-card-border-radius);
  box-shadow: var(--ids-card-shadow);
  margin-block-end: var(--ids-card-margin-bottom);
  height: max-content;
  overflow: hidden;
  position: relative;
  width: var(--ids-card-width);
}
.ids-card .ids-card-content {
  height: var(--ids-card-content-height);
  overflow: auto;
  width: 100%;
  overflow-x: hidden;
  position: relative;
}
.ids-card .ids-card-content.overflow-hidden {
  overflow: hidden;
}
.ids-card .ids-card-content.has-data-grid {
  overflow: hidden;
}
.ids-card .ids-card-content.has-data-grid ::slotted([slot=card-content]) {
  height: calc(100% + 3px);
  display: block;
}
.ids-card .ids-card-content ::slotted([slot=card-content]) {
  height: 100%;
  display: block;
}
.ids-card.shadowed {
  border: 1px solid transparent;
}
.ids-card-checkbox {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  bottom: 0;
  width: 50px;
  align-items: center;
  justify-content: center;
}
.ids-card.is-selectable {
  cursor: var(--ids-cursor-pointer);
}
.ids-card.is-selected {
  background-color: var(--ids-card-color-background-selected);
  outline: 2px solid var(--ids-card-color-border-selected);
  outline-offset: -1px;
}
.ids-card .hidden {
  display: none;
}

.ids-card-header {
  align-items: center;
  color: var(--ids-card-header-title-color);
  display: flex;
  padding-inline-start: var(--ids-card-header-padding-inline-start);
  padding-inline-end: var(--ids-card-header-padding-inline-start);
  height: var(--ids-card-header-height);
}

.ids-card-subheader {
  align-items: flex-start;
  color: var(--ids-card-header-title-color);
  display: flex;
  flex-direction: column;
  height: auto;
  padding-inline-start: var(--ids-card-header-padding-inline-start);
  padding-inline-end: var(--ids-card-header-padding-inline-start);
}

::slotted([slot=card-header]) {
  display: block;
  align-items: center;
  position: relative;
  width: 100%;
}

::slotted([slot=card-subheader]) {
  display: flex;
  align-items: center;
  padding-block-end: var(--ids-card-subheader-padding-block-end);
  position: relative;
  width: 100%;
}

::slotted([slot=card-subheader]:first-child) {
  padding-block-start: 0;
}

:host([no-header]) .ids-card-header {
  display: none;
}

:host([shadowed]) .ids-card {
  border: 1px solid var(--ids-box-shadowed-color-border);
  overflow-x: hidden;
}

.ids-card-footer {
  padding: 3px 0;
  display: none;
  bottom: 0;
  border-top: 1px solid var(--ids-card-divider-color-border);
  min-height: var(--ids-card-footer-height);
  overflow: hidden;
  width: 100%;
}
.ids-card-footer.no-padding {
  padding: 0;
}

:host([height]) .ids-card {
  height: 100%;
}
:host([height]) .ids-card .ids-card-content {
  height: calc(100% - 48px);
}
:host([height]) .has-footer .ids-card-content {
  height: calc(100% - 100px);
}

.has-footer .ids-card-content {
  height: 260px;
}
.has-footer .ids-card-footer {
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  overflow-x: hidden;
}

:host([auto-fit]) .ids-card {
  box-sizing: border-box;
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  min-height: auto;
}
:host([auto-fit]) .ids-card .ids-card-content {
  height: unset;
}

:host([auto-height]) .ids-card {
  min-height: auto;
  height: auto;
}
:host([auto-height]) .ids-card .ids-card-content {
  height: auto;
}
:host([auto-height]) .ids-card ids-button,
:host([auto-height]) .ids-card ids-hyperlink {
  height: auto;
}
:host([auto-height]) .ids-card ids-button::part(button),
:host([auto-height]) .ids-card ids-hyperlink::part(link) {
  height: auto;
}

:host([borderless]) .ids-card {
  border-color: var(--ids-color-transparent);
  box-shadow: none;
}
:host([borderless]) .ids-card:hover {
  border-color: transparent;
}

:host([actionable]) ids-hyperlink {
  height: 50px;
}
:host([actionable]) ids-hyperlink::part(link) {
  box-sizing: border-box;
  border: none;
  color: var(--ids-card-color-text-default);
  display: flex;
  margin: 0;
  padding: 0;
  text-align: center;
  text-decoration: none;
  width: 100%;
  white-space: normal;
}
:host([actionable]) ids-hyperlink::part(link):hover {
  color: var(--ids-card-color-text-hover);
}

:host .flex-content,
:host ::slotted(.flex-content) {
  display: flex;
  align-items: center;
  padding: 15px var(--ids-space-sm);
  gap: var(--ids-space-sm);
}

:host([actionable]) .ids-card {
  contain: unset;
  height: auto;
  transition: var(--ids-motion-duration) var(--ids-motion-ease);
}
:host([actionable]) .ids-card:hover {
  border: 1px solid var(--ids-card-color-border-hover);
}
:host([actionable]) .ids-card:not(.hide-focus):focus-within {
  border: 1px solid var(--ids-card-color-border-focus);
  box-shadow: var(--ids-shadow-30);
}
:host([actionable]) .ids-card ::slotted([slot=card-content]) {
  pointer-events: none;
  width: 100%;
}
:host([actionable]) .ids-card ids-button {
  align-items: center;
  height: 50px;
  width: 100%;
}
:host([actionable]) .ids-card ids-hyperlink::part(link),
:host([actionable]) .ids-card ids-button::part(button) {
  align-items: center;
  border: 1px solid transparent;
  background-color: var(--ids-color-transparent);
  height: 50px;
}
:host([actionable]) .ids-card ids-hyperlink::part(link):hover,
:host([actionable]) .ids-card ids-button::part(button):hover {
  background-color: var(--ids-color-transparent);
  color: var(--ids-button-tertiary-color-text-default);
}

.ids-card-body {
  width: 100%;
  overflow-x: hidden;
  height: inherit;
}
.ids-card-body.has-checkbox {
  padding-inline-start: 50px;
  width: calc(100% - 50px);
}

::slotted([slot=card-content].fixed-height) {
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: inherit;
  justify-content: center;
  padding: 0 var(--ids-space-xs);
  text-align: center;
  width: 100%;
}

:host([draggable]) {
  width: var(--ids-card-width);
  z-index: 1;
  transition: var(--ids-motion-duration) var(--ids-motion-ease);
}
:host([draggable]) .ids-card {
  border: 1px solid var(--ids-card-color-border-draggable);
  box-shadow: none;
  height: auto;
  min-height: auto;
  cursor: move;
  overflow-x: hidden;
}
:host([draggable]) .ids-card .ids-card-header {
  min-height: 56px;
}
:host([draggable]) .ids-card .ids-card-header slot[name=card-header] {
  display: flex;
  align-items: center;
  gap: 20px;
}
:host([draggable]) .ids-card:hover {
  background-color: var(--ids-card-color-background-hover);
  color: var(--ids-card-color-text-hover);
}
:host([draggable]) .ids-card:hover .ids-card-header slot[name=card-header] {
  color: var(--ids-card-color-text-hover);
}
:host([draggable]) .ids-card.is-overlapping {
  cursor: no-drop;
}
:host([draggable]) .ids-card.is-dropped {
  z-index: 99;
  width: var(--ids-card-width-dropped, var(--ids-card-width));
  height: var(--ids-card-height-dropped, "auto");
  background-color: var(--ids-card-color-background-dropped, #F5F5F5);
  opacity: 0.8;
}
:host([draggable]) .ids-card.is-dropped .ids-card-header slot[name=card-header] {
  color: var(--ids-card-color-text-default);
}
:host([draggable]) .ids-card.is-dragging {
  z-index: 999;
  width: var(--ids-card-width-dragged, var(--ids-card-width));
  height: var(--ids-card-height-dragged, "auto");
  background-color: var(--ids-card-color-background-dragged, #F5F5F5);
  opacity: 0.8;
}
:host([draggable]) .ids-card.is-dragging .ids-card-header slot[name=card-header] {
  color: var(--ids-card-color-text-default);
}
:host([draggable]) .ids-card.is-fixed.is-dropped, :host([draggable]) .ids-card.is-fixed.is-dragging {
  position: absolute;
  justify-content: center;
}
:host([draggable]) .ids-card.is-fixed.is-dropped .ids-card-header, :host([draggable]) .ids-card.is-fixed.is-dragging .ids-card-header {
  justify-content: center;
  align-items: center;
}

:host([draggable][is-dragging]) {
  z-index: 99;
  transition: none;
}

:host([draggable][dropped]) {
  z-index: 9;
  transition: none;
}

:host([disabled]) .ids-card {
  pointer-events: none;
  opacity: 0.5;
}

:host([actionable][height]) .ids-card ids-hyperlink {
  height: inherit;
}
:host([actionable][height]) .ids-card ids-hyperlink::part(link) {
  height: inherit;
}
:host([actionable][height]) .ids-card ids-button {
  height: inherit;
}
:host([actionable][height]) .ids-card ids-button::part(button) {
  height: inherit;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
